import { Injectable } from '@angular/core';
import { Identity } from 'src/store/identity/identity.model';
import { ConfigurationService } from './configuration.service';

@Injectable({ providedIn: 'root' })
export class IdentityService {
  public get(): Identity | undefined {
    const identityJson = localStorage.getItem(this._storageKey);
    if (identityJson != null) {
      try {
        return JSON.parse(identityJson) as Identity;
      } catch (err) {}
    }
    return undefined;
  }

  public set(identity: Identity) {
    localStorage.setItem(this._storageKey, JSON.stringify(identity));
  }

  public clear() {
    localStorage.removeItem(this._storageKey);
  }

  private get _storageKey() {
    return this._config.value.okta.enabled === true
      ? 'flight_log_identity_okta'
      : 'flight_log_identity';
  }

  constructor(private _config: ConfigurationService) {}
}
